
import sal from 'sal.js'
import 'sal.js/dist/sal.css';

export const careersAnimations = () => {
    sal();
};

